import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import "@fontsource/chivo";

const DiscountManager = () => {
  const [discounts, setDiscounts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [status, setStatus] = useState(null);
  const dropdownRef = useRef();

  const [newDiscount, setNewDiscount] = useState({
    name: "",
    percentage: "",
    category: [],
    active: false, // ✅ now default is NOT active
  });

  useEffect(() => {
    fetchDiscounts();
    fetchCategories();

    // Close dropdown when clicking outside
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const fetchDiscounts = () => {
    axios.get("https://api.lidodavittorio.it/api/discounts").then((res) => {
      setDiscounts(res.data);
    });
  };

  const fetchCategories = () => {
    axios.get("https://api.lidodavittorio.it/api/menu-table").then((res) => {
      setCategories(Object.keys(res.data));
    });
  };

  const handleCategoryToggle = (cat) => {
    setNewDiscount((prev) => ({
      ...prev,
      category: prev.category.includes(cat)
        ? prev.category.filter((c) => c !== cat)
        : [...prev.category, cat],
    }));
  };

  const handleAddDiscount = () => {
    const { name, percentage, category } = newDiscount;
    if (!name || !percentage || category.length === 0) {
      setStatus("❌ Tutti i campi sono obbligatori.");
      return;
    }

    axios
      .post("https://api.lidodavittorio.it/api/discounts", {
        ...newDiscount,
        category: category.join(", "),
      })
      .then(() => {
        setStatus(" ✅ Sconto aggiunto!");
        setNewDiscount({
          name: "",
          percentage: "",
          category: [],
          active: false,
        });
        fetchDiscounts();
      })
      .catch(() => setStatus("❌ Errore durante il salvataggio."));
  };

  const toggleDiscount = (id, active) => {
    axios
      .post("https://api.lidodavittorio.it/api/discounts/toggle", { id, active })
      .then(() => fetchDiscounts());
  };

  const activeDiscount = discounts.find((d) => d.active);


  const handleDeleteDiscount = (id) => {
    if (window.confirm("Sei sicuro di voler eliminare questo sconto?")) {
      axios
        .post("https://api.lidodavittorio.it/api/discounts/delete", { id })
        .then(() => {
          setStatus("🗑️ Sconto eliminato!");
          fetchDiscounts();
        })
        .catch(() => setStatus("❌ Errore durante l'eliminazione."));
    }
  };
  

  return (
    <div className="mt-10 font-[chivo]">
      <h3 className="text-2xl font-bold text-[#009FB7] mb-4 text-center">
        Gestione Sconti
      </h3>

      {/* 🟢 Active Discount in one row */}
{/* 🟢 Active Discount in one row */}
{activeDiscount ? (
  <div className="bg-green-100 border border-green-300 text-green-800 px-4 py-3 mb-6 rounded text-center">
    🟢 <strong>{activeDiscount.name}</strong> |{" "}
    <strong>{activeDiscount.percentage}%</strong> |{" "}
    <strong>Categorie:</strong> {activeDiscount.category}
  </div>
) : (
  <div className="bg-yellow-100 border border-yellow-300 text-yellow-800 px-4 py-3 mb-6 rounded text-center">
    ⚠️ Nessuno sconto attivo al momento
  </div>
)}


      {/* 🎯 Add Discount */}
      <div className="flex flex-wrap items-center gap-2 mb-4">
        <input
          type="text"
          placeholder="Nome Sconto"
          value={newDiscount.name}
          onChange={(e) =>
            setNewDiscount({ ...newDiscount, name: e.target.value })
          }
          className="border px-3 py-2 rounded w-full sm:w-[180px]"
        />

        <input
          type="number"
          placeholder="% Sconto"
          value={newDiscount.percentage}
          onChange={(e) =>
            setNewDiscount({ ...newDiscount, percentage: e.target.value })
          }
          className="border px-3 py-2 rounded w-full sm:w-[120px]"
        />

        {/* ⬇️ Dropdown with checkboxes */}
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="border px-3 py-2 rounded bg-white w-[180px] text-left"
          >
            {newDiscount.category.length > 0
              ? `${newDiscount.category.length} categorie selezionate`
              : "Seleziona categorie"}
          </button>

          {dropdownOpen && (
            <div className="absolute z-10 mt-1 w-[180px] bg-white border shadow-lg rounded max-h-48 overflow-y-auto">
              {categories.map((cat, idx) => (
                <label
                  key={idx}
                  className="flex items-center px-3 py-1 hover:bg-gray-100 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    checked={newDiscount.category.includes(cat)}
                    onChange={() => handleCategoryToggle(cat)}
                    className="mr-2"
                  />
                  {cat}
                </label>
              ))}
            </div>
          )}
        </div>

        <button
          onClick={handleAddDiscount}
          className="bg-[#009FB7] text-white px-4 py-2 rounded hover:bg-[#007a91]"
        >
          ➕ Aggiungi Sconto
        </button>
      </div>

      {/* ✅ Status Message */}
      {status && (
        <div className="text-sm text-[#009FB7] mb-4 flex items-center gap-2">
           {status}
        </div>
      )}

      {/* 📋 Discounts Table */}
      <table className="w-full text-sm border font-[chivo]">
        <thead className="bg-gray-200">
          <tr>
            <th className="p-2 border">ID</th>
            <th className="p-2 border">Nome</th>
            <th className="p-2 border">% Sconto</th>
            <th className="p-2 border">Categorie</th>
            <th className="p-2 border">Stato</th>
            <th className="p-2 border">Toggle</th>
          </tr>
        </thead>
        <tbody>
          {discounts.map((disc) => (
            <tr key={disc.id} className="border-b hover:bg-gray-50">
              <td className="p-2 text-center">{disc.id}</td>
              <td className="p-2">{disc.name}</td>
              <td className="p-2 text-center">{disc.percentage}%</td>
              <td className="p-2">{disc.category}</td>
              <td className="p-2 text-center">
                <span
                  className={`font-bold ${
                    disc.active ? "text-green-600" : "text-red-500"
                  }`}
                >
                  {disc.active ? "ATTIVO" : "DISATTIVO"}
                </span>
              </td>
              <td className="p-2 text-center flex justify-center items-center gap-2">
  <button
    onClick={() => toggleDiscount(disc.id, !disc.active)}
    className="text-xl hover:scale-110 transition"
    title={disc.active ? "Disattiva" : "Attiva"}
  >
    {disc.active ? "🟢" : "🔴"}
  </button>

  <button
    onClick={() => handleDeleteDiscount(disc.id)}
     className="text-red-600 font-bold px-2 hover:text-red-800"
    title="Elimina"
  >
    🗑
  </button>
</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DiscountManager;
